module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"root":"WaveSurfer","commonjs2":"wavesurfer.js","commonjs":"wavesurfer.js","amd":"wavesurfer"}
// module id = 1
// module chunks = 0